import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * Fires an RPM heartbeat every INTERVAL seconds while a provider is scoped
 * to a patient. Silent — errors are swallowed. Uses document.visibilityState
 * so it doesn't accumulate time on a hidden tab.
 */
const INTERVAL_MS = 60_000; // 60 seconds
const SECONDS_PER_TICK = 60;

export default function useRpmHeartbeat() {
  const { user, viewingPatient } = useAuth();
  const timerRef = useRef(null);

  useEffect(() => {
    // Only when provider is actively viewing a patient
    if (user?.role !== "provider" || !viewingPatient?.patient_id) return;

    const pid = viewingPatient.patient_id;
    let mounted = true;
    const tick = async () => {
      if (!mounted) return;
      if (document.visibilityState !== "visible") return;
      try {
        await api.post("/provider/rpm/heartbeat", { patient_id: pid, seconds: SECONDS_PER_TICK });
      } catch { /* ignore heartbeat failures */ }
    };
    timerRef.current = setInterval(tick, INTERVAL_MS);
    return () => {
      mounted = false;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [user, viewingPatient]);
}
